import React, { useContext, useState, useEffect } from 'react';
import { Button, Form, Input, AutoComplete } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm';
import { useSelector } from 'react-redux';
import { validationContent } from '../../../constants/Validation';
import { PlaceholderContent } from '../../../constants/Placeholder';

const AboutBusiness = () => {
  const FormData = useContext(MultiStepFormData);
  const info = useSelector(state => state.BusinessInfoReducer?.businessInfo);
  const businessAddressFromRedux = useSelector(state => state.BusinessInfoReducer?.businessInfo?.old_business_address);
  const businessPhoneFromRedux = useSelector((state) => state.Login?.user?.phoneNumber);

  const content = validationContent?.SIGNUP_STEPS;
  const placeholderContent = PlaceholderContent?.BILLING_ADDRESS;
  const businessDescriptionMaxLength = 200;

  const [isInitialized, setIsInitialized] = useState(false);
  const [phone, setPhone] = useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);

  const [formData, setFormData] = useState({
    name: '',
    address: '',
    contact_number: '',
  });

  // Check if all required fields are filled (minimum 2 characters each)
  const allValuesNotEmpty = obj => Object.values(obj).every(value => value?.trim().length >= 2);

  const onChange = (value, fieldName) => {
    const updatedFormData = { ...FormData.formData };
    updatedFormData[fieldName] = value;
    FormData.setFormData(updatedFormData);

    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const validateForm = () => {
    // Check if all three fields are filled (minimum 2 characters each)
    const isDataValid = allValuesNotEmpty({
      name: formData.name,
      address: formData.address,
      contact_number: formData.contact_number
    });

    if (isDataValid) {
      // Set form verification for the current page (page 1)
      const updatedFormVerified = Array.isArray(FormData.formVerified) ? [...FormData.formVerified] : [false, false];
      updatedFormVerified[1] = true;
      FormData.setFormVerified(updatedFormVerified);
    } else {
      // Set form verification for the current page (page 1)
      const updatedFormVerified = Array.isArray(FormData.formVerified) ? [...FormData.formVerified] : [false, false];
      updatedFormVerified[1] = false;
      FormData.setFormVerified(updatedFormVerified);
    }
  };

  // Initialize contact number from user data
  useEffect(() => {
    if (businessPhoneFromRedux) {
      const updatedFormData = { ...formData };
      updatedFormData.contact_number = businessPhoneFromRedux;
      setFormData(updatedFormData);
      
      // Also update the main form data
      const updatedMainFormData = { ...FormData.formData };
      updatedMainFormData.contact_number = businessPhoneFromRedux;
      FormData.setFormData(updatedMainFormData);
    }
  }, [businessPhoneFromRedux]);


  // Validate form whenever form data changes
  useEffect(() => {
    // Only validate if FormData.formVerified is properly initialized
    if (FormData.formVerified && typeof FormData.setFormVerified === 'function') {
      validateForm();
    }
  }, [formData]);

  return (
    <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }} className="text-center about_business">
      <Form
        initialValues={{
          contact_number: formData.contact_number || businessPhoneFromRedux || undefined,
          name: formData.name || undefined,
          address: formData.address || undefined,
        }}
        className="form_body text-start"
        style={{ paddingBottom: 'calc(20px + 1vh)' }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <div style={{ maxWidth: '640px', marginLeft: 'auto', marginRight: 'auto' }}>

          <div className="wrap">
            <div className="cnt" style={{  }}>
              <label htmlFor="" className="text_red d-block text-start sm placeholder_left">
              Bureau/Broker Name
              </label>
              <Form.Item
                style={{ marginBottom: 0 }}
                name="name"
                rules={[
                  {
                    required: true,
                    message: content?.name || 'Please enter broker name',
                  }
                ]}
              >
                <Input
                  maxLength={50}
                  className='input_field text_transform_normal'
                  placeholder="Enter Bureau/Broker Name"
                  onChange={(e) => onChange(e.target.value, 'name')}
                  value={formData?.name}
                />
              </Form.Item>
            </div>
            <div className="cnt text-left contact_num">
              <label htmlFor="" className="text_red d-bloc sm text-start placeholder_left">
              WhatsApp Number
              </label>
              <div className="country_code_wrap">
                <span className='country_code'>+91</span>
                <Form.Item
                  name="contact_number"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your Contact Number',
                    },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: 'Please enter a valid 10-digit Contact Number',
                    },
                  ]}
                >
                  <Input
                    disabled={true}
                    className='input_field'
                    placeholder=" 999 56 57 XXXX"
                    style={{
                      margin: '10px auto',
                      color: '#9E9E9E',
                      boxShadow: 'none',
                      outline: 'none',
                      height: 'calc(1vw + 38px)'
                    }}
                    type="text"
                    maxLength={10}
                    onChange={(e) => onChange(e.target.value, 'contact_number')}
                    onKeyDown={(e) => {
                      if (!(e.key === 'Backspace' || e.key === 'Delete' || /^\d$/.test(e.key))) {
                        e.preventDefault();
                      }
                    }}
                    value={formData?.contact_number}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="cnt description_wrap">
            <label htmlFor="" className="text_red sm d-block text-start placeholder_left">
              Address
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%'}}>
              <Form.Item
                style={{ marginBottom: 0 }}
                name="address"
                rules={[
                  {
                    required: true,
                    message: content?.EnterBusinessAddress || 'Please enter address',
                  }
                ]}
              >
                <TextArea
                  placeholder={placeholderContent?.Address || "Add Your Address"}
                  className="custom input_field no-resize"
                  style={{ margin: '10px auto' }}
                  maxLength={businessDescriptionMaxLength}
                  rows={4}
                  onChange={(e) => onChange(e.target.value, 'address')}
                  value={formData?.address}
                />
              </Form.Item>
            </div>
            <div className="">
              <span className={`form_note ${formData.address?.length === businessDescriptionMaxLength ? 'limit' : ''}`}>
                <span>{formData.address?.length || 0}</span>/{businessDescriptionMaxLength}
              </span>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AboutBusiness;
